import React, { FC } from 'react';
import Error from 'ati-ui-react/components/icons/Error';
import { HeadingContainer, Icon, CarefulState } from './HeadingStyles';

interface IHeading {
  icon: JSX.Element;
  // TODO FIX IT
  descr: any;
  beCarefulState?: boolean;
  isBorder?: boolean;
}

const Heading: FC<IHeading> = ({ icon, descr, beCarefulState, isBorder }) => {
  return (
    <>
      <HeadingContainer isBorder={isBorder} isColor={beCarefulState}>
        <Icon>{icon}</Icon>
        <span>{descr}</span>
        {beCarefulState && (
          <CarefulState>
            <Error width={20} height={20} />
          </CarefulState>
        )}
      </HeadingContainer>
    </>
  );
};

export default Heading;
